<div [ngClass]="{ 'stand-alone-modal': standAlone }">
    <div class="modal is-active" [ngClass]="modalSize">
        <div class="modal-background" (click)="backdropClicked()"></div>
        <div class="modal-content">
            @if (closeActive) {
                <div class="modal-header">
                    <button class="modal-close is-large" type="button" (click)="closeClicked()">
                        <span class="sr-only">Close</span>
                    </button>
                </div>
            }
            <div class="modal-body">
                <ng-template #insertionComp></ng-template>
            </div>
        </div>
    </div>
</div>
